import axios from '@/plugins/axios';

export default {
  namespaced: true,

  state: {
    token: localStorage.getItem('token') || null,
    user: null
  },

  mutations: {
    SET_TOKEN(state, token) {
      state.token = token;
      if (token) {
        localStorage.setItem('token', token);
      } else {
        localStorage.removeItem('token');
      }
    },
    SET_USER(state, user) {
      state.user = user;
      if (user) {
        localStorage.setItem('user', JSON.stringify(user));
      } else {
        localStorage.removeItem('user');
      }
    },
    CLEAR_AUTH(state) {
      state.token = null
      state.user = null
      localStorage.removeItem('token')
      localStorage.removeItem('user')
    }
  },

  actions: {
    async login({ commit }, { email, password }) {
      try {
        const response = await axios.post('/api/auth/signin', {
          email,
          password
        });

        const { accessToken, ...userData } = response.data;
        console.log('Login successful, token:', accessToken);
        
        commit('SET_TOKEN', accessToken);
        commit('SET_USER', userData);
        
        console.log('Token after storing:', localStorage.getItem('token'));

        return response.data;
      } catch (error) {
        console.error('Login error:', error);
        throw error.response?.data?.message || 'Login failed';
      }
    },

    logout({ commit }) {
      commit('CLEAR_AUTH')
    }
  },

  getters: {
    isAuthenticated: state => !!state.token,
    isAdmin: state => state.user?.role === 'ADMIN',
    currentUser: state => state.user
  }
};
